import React, { forwardRef, useState } from "react";
import DOMPurify from "dompurify";

import { StyledTextAreaContainer } from "@/components/ui/TextArea/StyledTextArea";

export interface ITextArea {
  placeholder?: string;
  required?: boolean;
  onChange?: (e: string) => void;
  error?: string;
  $marginbottom?: string;
  $borderColor?: string;
  bgColor?: string;
  label?: string;
  disabled?: boolean;
  $dataId?: string;
  maxLength?: number;
  $borderRadius?: string;
  labelClassName?: string;
  containerClassName?: string;
  textAreaClassName?: string;
  [key: string]: unknown;
}

const TextArea: React.FC<ITextArea> = forwardRef(
  (
    {
      placeholder,
      required,
      onChange,
      error,
      maxLength,
      $marginbottom,
      $borderColor,
      label,
      disabled,
      $borderRadius,
      labelClassName,
      containerClassName,
      textAreaClassName = "bg-[var(--inputBgColor)] min-h-[10rem] text-text-primary",
      $dataId,
      ...props
    }: ITextArea,
    ref: React.Ref<HTMLTextAreaElement>
  ) => {
    const [value, setValue] = useState<string>("");

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value;
      const sanitizedValue = DOMPurify.sanitize(value);
      setValue(sanitizedValue);

      if (onChange) onChange(sanitizedValue);
    };

    return (
      <StyledTextAreaContainer
        $marginbottom={$marginbottom ?? "2rem"}
        // $borderColor={error ? "var(--error)" : ($borderColor ?? "var(--inputBorder)")}
        $borderColor={error ? "var(--error, #eb5757)" : ($borderColor ?? "#E5E5E5")}
        required={required}
        $borderRadius={$borderRadius ?? "0.5rem"}
        className={containerClassName}
      >
        {label ? <label className={labelClassName}>{label}</label> : null}
        <textarea
          placeholder={placeholder}
          required={required}
          onChange={handleChange}
          disabled={disabled}
          data-id={$dataId}
          maxLength={maxLength}
          className={textAreaClassName}
          {...props}
          ref={ref}
        />
        <div className='footer'>
          {error ? <p className='error'>{error}</p> : null}
          {maxLength ? (
            <p className='text-count'>
              {value.length}/{maxLength}
            </p>
          ) : null}
        </div>
      </StyledTextAreaContainer>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
